export default __webpack_public_path__ + "static/media/d.d30a40f6.svg";